import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Button, Stack, Typography} from '@mui/material';

import {MainHeader, PageWrapperLayout} from 'presentation/components';
import operationalCostImg from 'presentation/assets/images/medical-consultation.svg';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {ChatRoomsEnum, HomeEnum} from 'presentation/constants';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {StyledCard, StyledContainer, StyledImage} from './styles';
import {ServicesTypesEnum} from '../services/types';

const {
	telehealthTitle,
	emergencyTitle,
	authorizationsTitle,
	healthTitle,
	examTitle,
	odontoTitle,
	buttonChat,
	buttonGoHome,
	subtitle,
	description,
	pageTitle,
	title,
} = translations['pt-br'].privateFlow.financialPendency;

export function FinancialPendency() {
	const navigate = useNavigate();
	const {state} = useLocation() as {state: {type: ServicesTypesEnum}};
	const {callChatRoom} = useCallChatRoom();

	const headerTitle: Record<ServicesTypesEnum, string> = {
		[ServicesTypesEnum.HEALTH]: healthTitle,
		[ServicesTypesEnum.TELEHEALTH]: telehealthTitle,
		[ServicesTypesEnum.EXAMS]: examTitle,
		[ServicesTypesEnum.ODONTO]: odontoTitle,
		[ServicesTypesEnum.EMERGENCY_TELEHEALTH]: emergencyTitle,
		[ServicesTypesEnum.AUTHORIZATIONS]: authorizationsTitle,
		[ServicesTypesEnum.OTHERS]: '',
	};

	function handleBack() {
		navigate(HomeEnum.HOME_PAGE);
	}

	return (
		<PageWrapperLayout title={pageTitle}>
			<MainHeader
				title={state?.type ? headerTitle[state.type] : title}
				handleBack={handleBack}
				variant="subRoute"
				hideClose
			/>
			<StyledContainer>
				<StyledCard
					elevation={0}
					data-tag-id={AppointmentBookingEnum.VISUALIZOU_CARD_INADIMPLENCIA}>
					<Stack gap={2}>
						<Typography variant="h6">{subtitle}</Typography>
						<Typography color="text.secondary">{description}</Typography>
						<Stack gap={1}>
							<Button
								onClick={handleBack}
								size="large"
								data-tag-id={
									AppointmentBookingEnum.CLICK_VOLTAR_TELA_INICIAL_CARD_INADIMPLENCIA
								}>
								{buttonGoHome}
							</Button>

							<Button
								data-tag-id={
									AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_CARD_INADIMPLENCIA
								}
								variant="outlined"
								fullWidth
								size="large"
								onClick={() => callChatRoom(ChatRoomsEnum.APP)}>
								{buttonChat}
							</Button>
						</Stack>
					</Stack>
					<StyledImage>
						<img src={operationalCostImg} alt="Médico avaliando paciente" />
					</StyledImage>
				</StyledCard>
			</StyledContainer>
		</PageWrapperLayout>
	);
}
